const ReferralRouteNavigationOptions = {
  title: 'Refer a Friend',
  headerTitle: 'Refer a Friend',
  headerBackVisible: false,
};

export default ReferralRouteNavigationOptions;
